(() => {
  const selector = 'product-recommendations.related-products';

  const updateSection = (section) => {
    const scroller = section.querySelector('.related-products__scroller');
    const previousButton = section.querySelector('[data-related-products-direction="previous"]');
    const nextButton = section.querySelector('[data-related-products-direction="next"]');

    if (!scroller || !previousButton || !nextButton) {
      return;
    }

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    const hasOverflow = maxScroll > 4;

    section.classList.toggle('related-products--overflow', hasOverflow);
    previousButton.disabled = !hasOverflow || scroller.scrollLeft <= 4;
    nextButton.disabled = !hasOverflow || scroller.scrollLeft >= maxScroll - 4;
  };

  const updateAllSections = () => {
    document.querySelectorAll(selector).forEach(updateSection);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-related-products-direction]');

    if (!button) {
      return;
    }

    const section = button.closest(selector);
    const scroller = section?.querySelector('.related-products__scroller');

    if (!section || !scroller) {
      return;
    }

    const direction = button.dataset.relatedProductsDirection === 'previous' ? -1 : 1;
    const firstItem = scroller.querySelector('.grid__item');
    const distance = firstItem ? firstItem.getBoundingClientRect().width + 16 : scroller.clientWidth * 0.85;

    scroller.scrollBy({
      left: distance * direction,
      behavior: 'smooth',
    });

    window.setTimeout(() => updateSection(section), 260);
  });

  document.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateAllSections);
  }, true);

  window.addEventListener('resize', updateAllSections);

  new MutationObserver(updateAllSections).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.setTimeout(updateAllSections, 500);
})();
